import requests from "../util";

const url = "/seller-gateway";

const SellerGatewayApi = {
    create: (data: any) =>
        requests.post(`${url}`, data),

    findSeller: (params: { idSeller?: string; document?: string }) => {
        const query = new URLSearchParams();

        if (params.idSeller) query.append("idSeller", params.idSeller);
        if (params.document) query.append("document", params.document);

        return requests.get(`${url}/find-seller?${query.toString()}`);
    },

    updateBankAccount: (data: any) =>
        requests.patch(`${url}/bank-account`, data),

    updateSellerRates: (data: any) =>
        requests.patch(`${url}/rates`, data),

    findSellerRates: (sellerId: number) =>
        requests.get(`${url}/${sellerId}/rates`),

    findAllSellersRate: () =>
        requests.get(`${url}/sellers-rates`),

    requestRedeem: (sellerId: string, data: any) =>
        requests.post(`${url}/${sellerId}/redeems`, data),

    findTransferDetails: (sellerId: number, transferDate?: string) => {
        const query = transferDate
            ? `?transferDate=${encodeURIComponent(transferDate)}`
            : "";

        return requests.get(
            `${url}/${sellerId}/transfers/details${query}`
        );
    },

    findBalance: (sellerId: number) =>
        requests.get(`${url}/${sellerId}/balance`),

    findFutureReceivables: (
        idSeller: number,
        initialDate: string,
        finalDate: string
    ) => {
        const query = new URLSearchParams({
            idSeller: String(idSeller),
            initialDate: initialDate,
            finalDate: finalDate,
        });

        return requests.get(`${url}/reports/future-receivables?${query.toString()}`);
    },

    findReceivableDetails: (sellerId: number, date: string) =>
        requests.get(
            `${url}/${sellerId}/receivables/details?date=${encodeURIComponent(
                date
            )}`
        ),

    findByStoreId: (storeId: string) =>
        requests.get(`${url}/store/${storeId}`),

    deleteByStoreId: (storeId: string) =>
        requests.delete(`${url}/store/${storeId}`),

    findSellerTransactions: (
        sellerId: string,
        params: {
            startDate?: string;
            endDate?: string;
            page?: number;
            size?: number;
        }
    ) => {
        const query = new URLSearchParams();
        if (params.startDate) query.append("startDate", params.startDate);
        if (params.endDate) query.append("endDate", params.endDate);
        if (params.page != null) query.append("page", String(params.page));
        if (params.size != null) query.append("size", String(params.size));
        return requests.get(`${url}/${sellerId}/transactions?${query.toString()}`);
    },

    findStatement: (data: {
        idSeller?: string;
        cnpj?: string;
        executionDateInitial?: string;
        executionDateFinal?: string;
        uuid_order?: string;
        uuid_charge?: string;
    }) =>
        requests.post(`${url}/reports/statement`, data),

    refundCharge: (uuid: string, data: { asFraud?: boolean }) =>
        requests.patch(`${url}/${uuid}/refund`, data),

    partialRefundCharge: (uuid: string, data: { value: number }) =>
        requests.patch(`${url}/${uuid}/partial-refund`, data),

    findPartialRefund: (uuid: string) =>
        requests.get(`${url}/${uuid}/partial-refund`),
};



export default SellerGatewayApi;